import React from 'react';
import './style.less';

const S2 = () => (
  <React.Fragment>
    <div className="cloud1" />
    <div className="cloud2" />
    <div className="cloud3" />
    <div className="cloud4" />
    <div className="tree1" />
    <div className="tree2" />
    <div className="tree3" />
    <div className="tree4" />
    <div className="hedgehog" />
    <div className="leaf1" />
    <div className="leaf2" />
    <div className="leaf3" />
    <div className="leaf4" />
    <div className="leaf5" />
    <div className="leaf6" />
    <div className="leaf7" />
    <div className="pumpkin" />
  </React.Fragment>
);

export default S2;
